export interface actionType {
  type: string;
  payload?: any;
}

export function createAction(
  type: actionType['type'],
  payload?: actionType['payload']
) {
  return {
    type,
    payload,
  };
}